// extracted by mini-css-extract-plugin
module.exports = {"header":"AccordionHeader-module--header--1cUag","active":"AccordionHeader-module--active--2GCbR","svg":"AccordionHeader-module--svg--udXA5"};